import { Box, Button, Flex, FormControlSizes } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

interface TransferConfirmationCardProps {
  onResubmit: () => void;
}

export function TransferConfirmationCard({ children, onResubmit }: PropsWithChildren<TransferConfirmationCardProps>) {
  return (
    <Box background="gray.020" borderRadius="borderRadiusDefault" p="spacing12" fontSize="fontSizeSmall">
      <Flex flexDirection="column" gap="spacing12">
        {children}
        <Button size={FormControlSizes.Small} onClick={onResubmit} data-testid="transfer-confirmation-resubmit">
          Resubmit
        </Button>
      </Flex>
    </Box>
  );
}
